<template>
  <v-container fluid>
    <!-- <Dropshipping /> -->
    <v-row>
      <v-col cols="12" sm="4" md="4">
        <v-card class="shadow-small round">
          <v-card-title>
            <v-row>
              <v-col cols="12" sm="12" md="6">
                <!-- <p class="custom-title ml-4 weight-l">{{title}}</p> -->
                <span class="weight-l">Categorías</span>
              </v-col>
              <v-col cols="12" sm="12" md="6" class="py-0">
                <v-switch v-if="switch_publish" v-model="switch_publish" label="Por Publicar"></v-switch>
                <v-switch v-else v-model="switch_publish" label="Publicados"></v-switch>
              </v-col>
              <v-col cols="12">
                <v-text-field label="Buscar"></v-text-field>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text>
            <v-data-table
              :loading="loading"
              :headers="headers"
              :items="custom"
              :server-items-length="data.total"
              :options.sync="options"
              class="elevation-0"
              hide-default-footer
            >
              <template v-slot:body="{ items }">
                <tbody>
                  <tr
                    :class="key == selectedRow ? 'custom-highlight-row' : ''"
                    @click="handleClick(item, key)"
                    v-for="(item, key) in items"
                    :key="item.name"
                  >
                    <td>
                      <span>{{ item.name }}</span>
                      <v-spacer></v-spacer>
                    </td>
                    <td class="text-right">
                      <v-btn
                        v-if="key == selectedRow && item.status !== 'Publicado'"
                        class="mx-2 text-capitalize black--text caption elevation-1"
                        color="amber lighten-2"
                        x-small
                        @click="public_category(item)"
                      >Publicar</v-btn>
                      <v-btn
                        v-if="key == selectedRow && item.status == 'Publicado'"
                        class="mx-2 text-capitalize grey--text text--lighten-4 caption elevation-1"
                        color="teal"
                        x-small
                        dark
                        @click="published_category(item)"
                      >Publicado</v-btn>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-data-table>
            <!-- Paginación -->
            <v-row justify="end" v-if="AllCategories.length > 0">
              <v-col cols="auto">
                <v-pagination
                  circle
                  v-model="page"
                  :length="Pagination.page_count"
                  :total-visible="7"
                ></v-pagination>
              </v-col>
            </v-row>
            <!-- Fin de Paginación -->
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="8" md="8">
        <v-data-iterator
          :items="itemsProductCategory"
          :items-per-page.sync="itemsPerPage"
          :page="pageProduct"
          search
          :sort-desc="sortDesc"
          hide-default-footer
        >
          <template v-slot:header>
            <v-card-title>Productos</v-card-title>
          </template>

          <template v-slot:no-data>
            <v-card class="shadow-small round">
              <v-card-text v-if="searchProducts == false">
                <v-alert text dense color="primary" type="info" border="left">
                  <span>Selecciona una categoría para visualizar sus productos.</span>
                </v-alert>
              </v-card-text>
              <v-card-text v-if="searchProducts == true">
                <v-progress-linear indeterminate color="yellow darken-2"></v-progress-linear>
              </v-card-text>
            </v-card>
          </template>

          <template v-slot:default="props">
            <v-row v-if="!searchProducts">
              <v-col v-for="(item, index) in props.items" :key="index" cols="12" class="py-0">
                <v-card flat style="border-radius:0px" class="my-1 d-flex">
                  <v-card-text>
                    <v-row no-gutters align="center">
                      <v-col cols="12" sm="2">
                        <v-img
                          contain
                          height="100"
                          :lazy-src="item.pictures[0]"
                          :src="item.pictures[0]"
                          class="white lighten-2"
                          aspect-ratio="2"
                        >
                          <template v-slot:placeholder>
                            <v-row class="fill-height ma-0" align="center" justify="center">
                              <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                        <!-- <img
                          style="max-width: 100%;"
                          v-if="render2"
                          :src="JSON.parse(item.pictures)[0]"
                          alt="image-product"
                          height="100"
                        />-->
                      </v-col>
                      <v-col cols="12" sm="5" class="mr-2">
                        <p
                          class="font-weight-bold grey--text text--darken-2"
                          style="font-size: 12px; font-weight: 500"
                        >{{ item.title }}</p>
                        <div class="font-text-12">
                          <span class="font-weight-bold">Disponibilidad en el Stock: </span>

                          <span :class="textColor(item.stock_text)">{{ item.stock_text }}</span>
                        </div>
                        <div v-if="item.stock_text == 'No Disponible'" class="font-text-12">
                          <span class="font-weight-bold">Próximo ingreso:</span>
                          <span>{{item.available_date | dateStart}}</span>
                        </div>
                        <div class="font-text-12" v-if="item.status">
                          <span class="font-weight-bold">Publicación:</span>
                          <span>{{item.status}}</span>
                        </div>
                      </v-col>
                      <v-col cols="12" sm="4">
                        <span class="grey--text text--darken-3">
                          PVC:
                          {{ PVC(item.pvc, item.discount_step_b2b, item.stock) | currency}}
                          <span
                            style="font-size: 13px;"
                          >+ IVA {{ item.iva }} %</span>
                        </span>
                        <v-spacer></v-spacer>
                        <span class="grey--text text--darken-3">
                          PVP:
                          {{ item.pvp | currency}}
                        </span>
                      </v-col>
                      <v-btn
                        absolute
                        dark
                        top
                        right
                        x-small
                        v-if="switch_publish == false"
                        color="primary"
                        @click="edit_product(item)"
                      >
                        <!-- <v-icon>mdi-plus</v-icon> -->
                        Editar
                      </v-btn>
                      <v-btn
                        absolute
                        dark
                        bottom
                        right
                        x-small
                        v-if="switch_publish == false && item.status == 'Activo'"
                        color="grey"
                        @click="pause_product(item)"
                      >Pausar</v-btn>
                      <v-btn
                        absolute
                        dark
                        bottom
                        right
                        x-small
                        v-if="switch_publish == false && item.status == 'Pausado'"
                        color="teal"
                        @click="active_product(item)"
                      >Activar</v-btn>
                      <!-- <v-btn
                        absolute
                        dark
                        bottom
                        right
                        x-small
                        v-if="switch_publish == false"
                        color="grey"
                        @click="pause_product(item)"
                      >
                        Activar
                      </v-btn>-->
                    </v-row>
                  </v-card-text>
                  <v-divider></v-divider>
                </v-card>
              </v-col>
            </v-row>
            <!-- <v-row v-else>
              <v-col class="mx-auto">
                <looping-rhombuses-spinner
                  class="mx-auto"
                  :animation-duration="2500"
                  :rhombus-size="80"
                  color="#402DCE"
                />
              </v-col>
            </v-row>-->
          </template>

          <template v-slot:footer>
            <v-row class="mt-2" align="center" justify="center">
              <span class="grey--text">Elementos por pagina</span>
              <v-menu offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn dark text color="primary" class="ml-2" v-on="on">
                    {{ itemsPerPage }}
                    <v-icon>mdi-chevron-down</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-for="(number, index) in itemsPerPageArray"
                    :key="index"
                    @click="updateItemsPerPage(number)"
                  >
                    <v-list-item-title>{{ number }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>

              <v-spacer></v-spacer>

              <span
                class="mr-4 grey--text"
              >Pagina {{ current_page }} de {{ totalPage === null ? 0 : totalPage }}</span>
              <v-btn fab small dark color="blue darken-3" class="mr-1" @click="prevPage">
                <v-icon>mdi-chevron-left</v-icon>
              </v-btn>
              <v-btn fab small dark color="blue darken-3" class="ml-1" @click="nextPage">
                <v-icon>mdi-chevron-right</v-icon>
              </v-btn>
              <v-spacer></v-spacer>
            </v-row>
          </template>
        </v-data-iterator>
      </v-col>

      <!-- este es el modal que debes colocar en un componente aparte  -->
      <!-- <v-dialog v-model="dialog" width="800">
        <v-card>
          <v-card-title class="headline" primary-title>Editar Producto</v-card-title>

          <v-card-text>
            <v-text-field label="Titulo" v-model="item_product.title"></v-text-field>
            <v-textarea
              auto-grow
              rows="1"
              row-height="10"
              label="Descripción"
              v-model="item_product.description"
            ></v-textarea>

            <v-sheet class="mx-auto" max-width="700">
              <v-slide-group multiple show-arrows>
                <v-slide-item
                  v-for="n in pictures"
                  :key="n+'tt'"
                  v-slot:default="{ active, toggle }"
                >
                  <v-card
                    class="ma-4"
                    :input-value="active"
                    height="100"
                    width="180"
                    @click="toggle"
                  >
                    <v-img
                      contain
                      class="white--text align-end"
                      aspect-ratio="2"
                      :src="n"
                      :lazy-src="n"
                    ></v-img>
                  </v-card>
                </v-slide-item>
              </v-slide-group>
            </v-sheet>

            <v-file-input multiple label="Cargar Imagenes" v-model="item_product.pictures"></v-file-input>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="update_product(item_product)">Aceptar</v-btn>
            <v-btn color="#b2aaaa" dark @click="dialog = false">Cancelar</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>-->
      <ProductEdit
        :active="dialog"
        :item_product="item_product"
        :images="pictures"
        @dialog:change="HandlerEvent"
        v-if="dialog"
      />
    </v-row>
  </v-container>
</template>

<script>
import moment from "moment";
import ProductEdit from "./EditProduct";
// import Dropshipping from "../Dropshipping/Index"
import Swal from "sweetalert2";

export default {
  components: {
    ProductEdit
  },
  data() {
    return {
      // VARIABLES DATA TABLE
      switch_publish: true,
      dialog: false,
      item_product: "",
      page: 1,
      options: {},
      loading: false,
      model: null,
      pictures: [],
      headers: [
        {
          text: "Nombre",
          align: "start",
          sortable: false,
          value: "name"
        }
      ],
      selectedRow: null,
      // VARIABLES ITERADOR
      render2: false,
      data: [],
      pageProduct: 0,
      sortDesc: false,
      searchProducts: false,
      itemsPerPage: 20,
      itemsPerPageArray: [10, 20, 30],
      current_page: 0,
      totalPage: 0,
      nextURL: "",
      prevURL: ""
    };
  },

  filters: {
    dateStart(value) {
      return moment(value)
        .locale("es")
        .format("DD/MM/YYYY");
    }
  },

  created() {
    this.getCategories();
    this.dataMercadoLibre();
  },

  watch: {
    // MANEJADOR DE PAGINADO
    options: {
      async handler() {
        try {
          this.loading = true;
          const payload = {
            page: this.page,
            itemsPerPage: this.itemsPerPage
          };
          await this.$store.dispatch(
            "categories/GET_CATEGORIES_PAGINATE",
            payload
          );
          this.render2 = true;
        } catch (error) {
          console.error(error);
          this.$snotify.error(
            "Error al cargar listados de clientes.",
            "¡Vaya!"
          );
        } finally {
          this.loading = false;
        }
      },
      deep: true
    },

    switch_publish() {
      // this.itemsProductCategory = [];
      // this.searchProducts = false
      this.$store.commit("categories/SET_ARRAY_PRODUCT_CATEGORY");
    }
  },

  computed: {
    AllCategories() {
      return this.$store.getters["categories/GET_ALL_CATEGORIES"];
    },

    Pagination() {
      return this.$store.getters["categories/PAGINATION"];
    },

    itemsAccount() {
      return this.$store.getters["dropshipping/ITEMS_ACCOUNT"];
    },

    itemsProductCategory() {
      return this.$store.getters["categories/GET_PRODUCT_CATEGORY"];
    },

    custom() {
      let items = this.$store.getters["categories/GET_ALL_CATEGORIES"];
      if (this.switch_publish) {
        return items.filter(index => index.status == "Por Publicar");
      } else {
        return items.filter(index => index.status == "Publicado");
      }
    }
  },

  methods: {
    async nextPage() {
      try {
        if (this.nextURL !== null) {
          const request = {
            url: this.nextURL
          };
          const response = await this.$store.dispatch(
            "categories/HANDLER_PAGE",
            request
          );
          this.nextURL = response.links.next;
          this.prevURL = response.links.prev;
          this.current_page = response.meta.current_page;
        } else {
          this.$snotify.warning("No hay mas productos", "Consulta");
        }
      } catch (error) {
        this.$snotify.error("Consulte al administrador del sistema", "Error");
      }
    },

    async prevPage() {
      try {
        if (this.prevURL !== null) {
          const request = {
            url: this.prevURL
          };
          const response = await this.$store.dispatch(
            "product/HANDLER_PAGE",
            request
          );
          this.nextURL = response.links.next;
          this.prevURL = response.links.prev;
          this.current_page = response.meta.current_page;
        } else {
          this.$snotify.warning("No hay mas productos", "Consulta");
        }
      } catch (error) {
        this.$snotify.error("Consulte al administrador del sistema", "Error");
      }
    },

    async handleClick(value, key) {
      try {
        if (this.switch_publish) {
          this.selectedRow = key;
          this.searchProducts = true;
          // CONSULTA POR PUBLICAR
          const response = await this.$store.dispatch(
            "categories/GET_CATEGORY_PRODUCT",
            {
              id: value.id
            }
          );
          console.log("consulta productos por publicar", response.data);
          this.nextURL = response.data.links.next;
          this.prevURL = response.data.links.prev;
          this.totalPage = response.data.meta.last_page;
          this.current_page = response.data.meta.current_page;
          // this.data = response.data.data;
          this.searchProducts = false;
        } else {
          this.selectedRow = key;
          this.searchProducts = true;
          // CONSULTA POR PUBLICADOS
          const response = await this.$store.dispatch(
            "categories/GET_CATEGORY_PRODUCT_PUBLISHED",
            { id: value.id }
          );
          console.log("consulta productos publicados", response.data);
          // console.log("Publicados",response.data);
          // this.data = response.data.data;
          this.searchProducts = false;
        }
      } catch (error) {
        this.searchProducts = false;
        console.log(error);
      }
    },

    updateItemsPerPage(number) {
      this.itemsPerPage = number;
    },

    details(product) {
      this.$store.commit("product/SET_ONE_PRODUCT", product);
      this.$router.push({
        name: "details_products",
        params: { id: product.id }
      });
    },

    async getCategories() {
      try {
        this.loading = true;
        await this.$store.dispatch("categories/GET_CATEGORIES");
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },

    async public_category(item) {
      console.log("public category", item);
      try {
        Swal.fire({
          title: "Estas seguro que desea publicar esta categoría ?",
          // text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#7160ec",
          cancelButtonColor: "#b2aaaa",
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar"
        }).then(result => {
          if (result.value) {
            this.public(item);
          }
          console.log("***************************************************");
        });
      } catch (e) {
        console.log("yyyyyyyyy", e.response.data.user_ml);
      }
    },
    async public(item) {
      try {
        const request = {
          category_id: item.id,
          user_ml: this.itemsAccount[0].id
        };
        console.log("request", request);
        await this.$store.dispatch("categories/PUBLISH_CATEGORY", request);

        Swal.fire({
          title: "Publicado !",
          text: "Tu categoría a sido publicada con éxito.",
          icon: "success",
          confirmButtonColor: "#7160ec"
        });
      } catch (e) {
        Swal.fire({
          title: e.response.data.user_ml,
          icon: "error",
          showCancelButton: true,
          confirmButtonColor: "#7160ec",
          cancelButtonColor: "#b2aaaa",
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar"
        });
        console.log(e);
      }
    },
    async published_category(item) {
      console.log("public category", item);
      try {
        Swal.fire({
          title:
            "Estas seguro que desea desactivar la publicacion de esta categoría ?",
          // text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#7160ec",
          cancelButtonColor: "#b2aaaa",
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar"
        }).then(result => {
          if (result.value) {
            Swal.fire({
              title: "Desactivada publicación !",
              text: "Tu categoría a sido desactivada con éxito.",
              icon: "success",
              confirmButtonColor: "#7160ec"
            });
          }
        });
      } catch (e) {
        console.log("yyyyyyyyy", e.response);
      }
    },
    textColor(item) {
      if (item == "Disponibilidad Normal") {
        return "font-text-12  bg-green";
      } else if (item == "Disponibilidad Baja") {
        return "font-text-12  bg-yellow";
      } else if (item == "No Disponible") {
        return "font-text-12  bg-red";
      } else {
        return "font-text-12 bg-pink";
      }
    },
    PVC(pvc, discount, count) {
      let pvc_total_product = 0;
      let pvc_total = 0;
      if (count > 0) {
        let data_product = discount[count - 1];

        let discount_product =
          data_product == undefined ? 0 : data_product.discount;

        pvc_total_product = pvc - (pvc * discount_product) / 100;

        pvc_total =
          pvc_total_product - pvc_total_product * (discount_product / 100);
      } else {
        pvc_total = pvc;
      }
      return pvc_total;
    },
    async dataMercadoLibre() {
      try {
        await this.$store.dispatch("dropshipping/INDEX");
      } catch (e) {
        // statements
        console.log(e.response);
      }
    },
    edit_product(item) {
      this.item_product = item;
      this.pictures = item.pictures;
      // console.log("** item", typeof JSON.parse(item.pictures));
      this.dialog = true;
    },
    pause_product(item) {
      console.log("** pause product", item);
      try {
        Swal.fire({
          title:
            "Estas seguro que desea pausar la publicación de este producto ?",
          // text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#7160ec",
          cancelButtonColor: "#b2aaaa",
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar"
        }).then(result => {
          if (result.value) {
            this.pause(item);
            // Swal.fire({
            //   title: "Pausado !",
            //   text: "La publicación de tu producto a sido pausada con éxito.",
            //   icon: "success",
            //   confirmButtonColor: "#7160ec"
            // })
          }
        });
      } catch (e) {
        console.log("yyyyyyyyy", e.response);
      }
    },
    async pause(item) {
      try {
        console.log(item);
        const request = {
          id: item.item_id
        };
        console.log("request", request);
        await this.$store.dispatch("publications/PAUSE", request);
        // console.log(response);

        Swal.fire({
          title: "Pausado !",
          text: "La publicación de tu producto a sido pausada con éxito.",
          icon: "success",
          confirmButtonColor: "#7160ec"
        });
      } catch (e) {
        Swal.fire({
          title: "e.response.data.user_ml",
          icon: "error",
          showCancelButton: true,
          confirmButtonColor: "#7160ec",
          cancelButtonColor: "#b2aaaa",
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar"
        });
        console.log(e);
      }
    },
    active_product(item) {
      console.log("** pause product", item);
      try {
        Swal.fire({
          title:
            "Estas seguro que desea activar la publicación de este producto ?",
          // text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#7160ec",
          cancelButtonColor: "#b2aaaa",
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar"
        }).then(result => {
          if (result.value) {
            this.active(item);
          }
        });
      } catch (e) {
        console.log("yyyyyyyyy", e.response);
      }
    },
    async active(item) {
      try {
        console.log(item);
        const request = {
          id: item.item_id
        };
        console.log("request", request);
        await this.$store.dispatch("publications/ACTIVE", request);
        // console.log(response);

        Swal.fire({
          title: "Activado !",
          text: "La publicación de tu producto a sido activada con éxito.",
          icon: "success",
          confirmButtonColor: "#7160ec"
        });
      } catch (e) {
        Swal.fire({
          title: "e.response.data.user_ml",
          icon: "error",
          showCancelButton: true,
          confirmButtonColor: "#7160ec",
          cancelButtonColor: "#b2aaaa",
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar"
        });
        console.log(e);
      }
    },
    // async update_product(item_product) {
    //   try {
    //     console.log("item_product", item_product);
    //     const request = {
    //       title: item_product.title,
    //       post_ml: item_product.item_id,
    //       description: item_product.description,
    //       pictures: item_product.pictures
    //     };

    //     // { item_id: item_product.item_id },
    //     // { description: item_product.description },
    //     // { pictures: item_product.pictures },
    //     // // title: item_product.title,
    //     // //   description: item_product.description,
    //     // //   pictures: item_product.pictures,
    //     // ];
    //     console.log("request", request);
    //     const response = await this.$store.dispatch(
    //       "categories/UPDATE_PRODUCT",
    //       request
    //     );
    //     console.log(response);

    //     this.dialog = false;

    //     Swal.fire({
    //       title: "Actualizado !",
    //       text: "Tu producto ha sido actualizado con éxito.",
    //       icon: "success",
    //       confirmButtonColor: "#7160ec"
    //     });
    //   } catch (e) {
    //     console.log("status", e.response.data.status);
    //     if (e.response.data.status == 400) {
    //       Swal.fire({
    //         title: "Actualizacion fallida",
    //         text:
    //           "No se lograron actualizar los datos de sus productos, por favor intente mas tarde.",
    //         icon: "error",
    //         showCancelButton: true,
    //         confirmButtonColor: "#7160ec",
    //         cancelButtonColor: "#b2aaaa",
    //         confirmButtonText: "Aceptar",
    //         cancelButtonText: "Cancelar"
    //       });
    //     } else {
    //       Swal.fire({
    //         title: "Lo sentimos",
    //         text: "consulte al administrador.",
    //         icon: "error",
    //         showCancelButton: true,
    //         confirmButtonColor: "#7160ec",
    //         cancelButtonColor: "#b2aaaa",
    //         confirmButtonText: "Aceptar",
    //         cancelButtonText: "Cancelar"
    //       });
    //     }

    //     this.dialog = false;

    //     console.log(e);
    //   }
    // },
    HandlerEvent(message) {
      console.log(message);
      this.dialog = false;
    }
  }
};
</script>

<style>
.custom-highlight-row {
  background-color: #dbdbdb !important;
}
.font-text-12 {
  font-size: 12px;
}
.stock {
  background-color: #eee;
  padding: 3px;
  border-radius: 10px;
}
.bg-green {
  color: #04b29b;
}
.bg-yellow {
  color: #f09804;
}
.bg-red {
  color: #c72b27;
}
.bg-pink {
  color: #d81b60;
}
</style>